module.exports = __webpack_public_path__ + "img/cerrar_filtro_catalogo.7145041d.svg";